import React from 'react';

import { flagStyles } from '../settings';

const SvgBW = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-792px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgBW;
